import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Seo } from "../components/Seo";
import { Footer } from "../components/Footer";
import { DESTINATIONS } from "../data/destinations";
import { Compass, ArrowRight } from "lucide-react";

const TIPS = [
  { t: "Set a realistic budget", d: "Decide a rough total first — WanderlyMe plans hotels, food and activities to fit it and flags when you go over." },
  { t: "Travel in shoulder season", d: "Late spring and early autumn bring fewer crowds, lower prices and kinder weather in most regions." },
  { t: "Base yourself centrally", d: "A well-located stay means more time exploring and less time commuting — our plans pick neighbourhoods near your itinerary." },
  { t: "Leave room for hidden gems", d: "The best memories are rarely on the top-10 lists. Ask locals — or let WanderlyMe surface them for you." },
];

export default function TravelGuide() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: "The WanderlyMe Travel Guide",
    description: "Practical travel planning tips and curated destination guides to help you plan a better trip.",
    author: { "@type": "Organization", name: "WanderlyMe" },
    publisher: { "@type": "Organization", name: "WanderlyMe" },
    mainEntityOfPage: "https://wanderlyme.com/travel-guide",
  };
  return (
    <div className="min-h-screen grain relative">
      <Seo
        title="Travel Guide — Tips & Destination Ideas"
        description="Smart travel planning tips and curated destination guides. Learn how to plan trips on any budget and get inspired for your next adventure with WanderlyMe."
        path="/travel-guide"
        jsonLd={jsonLd}
      />
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 py-12">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#C8553D] mb-4">
          <Compass className="w-4 h-4" /> The WanderlyMe guide
        </span>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-4">Plan a better trip</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mb-12">
          A few principles behind every great itinerary — plus curated guides to some of our favourite destinations.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-16">
          {TIPS.map((tip, i) => (
            <div key={i} className="p-7 rounded-2xl border border-black/5 bg-white/60">
              <h2 className="font-display text-2xl mb-2">{tip.t}</h2>
              <p className="text-muted-foreground leading-relaxed">{tip.d}</p>
            </div>
          ))}
        </div>

        <h2 className="font-display text-3xl mb-6">Popular destination guides</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {DESTINATIONS.map((d) => (
            <Link
              key={d.slug}
              to={`/destinations/${d.slug}`}
              className="group flex items-center justify-between p-4 rounded-xl border border-black/5 bg-white/60 hover:border-[#C8553D] transition-colors"
            >
              <span className="font-medium">{d.name}</span>
              <ArrowRight className="w-4 h-4 text-[#C8553D] group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
